import { useVideoUploadQueue } from '@/stores/videoUploadQueue';
import { storeToRefs } from 'pinia';
import { computed, onUnmounted } from 'vue';

export function useServiceVideoUploadLifecycle() {
    const uploadQueue = useVideoUploadQueue();
    const { activeJob } = storeToRefs(uploadQueue);

    const shouldWarnBeforeUnload = computed(() => {
        const status = activeJob.value?.status;

        return status === 'uploading' || status === 'processing';
    });

    function handleBeforeUnload(event: BeforeUnloadEvent): void {
        if (!shouldWarnBeforeUnload.value) {
            return;
        }

        event.preventDefault();
        event.returnValue = '';
    }

    window.addEventListener('beforeunload', handleBeforeUnload);

    onUnmounted(() => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
    });

    return {
        shouldWarnBeforeUnload,
    };
}
